import { render, staticRenderFns } from "./ItemPropertiesComponent.vue?vue&type=template&id=f6c18c5c&scoped=true&"
import script from "./ItemPropertiesComponent.vue?vue&type=script&lang=js&"
export * from "./ItemPropertiesComponent.vue?vue&type=script&lang=js&"
import style0 from "./ItemPropertiesComponent.vue?vue&type=style&index=0&id=f6c18c5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c18c5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VAutocomplete,VBtn,VDatePicker,VIcon,VMenu,VSpacer,VTextField,VTimePicker})
